import { takeLatest, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import HttpService from "../../../services/HttpService";

export function* onSavePlan({ payload }) {
	try {
		const { requests } = payload;
		const response = yield HttpService.saveEvents(requests);
		if (!response.success) {
			throw Error("Não foi possível carregar os planos cadastrados.");
		}
	} catch (err) {
		toast.error("Não foi possível pegar os planos cadastrados.");
	}
}

export default all([takeLatest("@analytics/SAVE_EVENT", onSavePlan)]);
